export default {
  en: {
    GOODSHAPE_INTERACTION_UPDATED: "GoodShape Interaction was successfully updated",
    ADDITIONAL_INFO_UPDATED: "Additional Info was successfully updated",
    NOTE_ADDED: "Note successfully added",
    NOTE_UPDATED: "Note successfully updated",
    NOTE_DELETED: "Note successfully deleted",
    DOCUMENT_ADDED: "Document was successfully added",
    DOCUMENT_REMOVED: "Document was successfully removed",
    NOTIFICATION_AUDIT: " Notification Audit",
    NOTIFICATION_AUDIT_DUE: "Notification Audit Due",
    NOTIFICATION_AUDIT_DUE_TEXT_LINE1:
      "It is important to ensure that you are set-up to receive the correct notifications. To support with achieving this you are required to complete an audit of your My Employees list.",
    NOTIFICATION_AUDIT_DUE_TEXT_LINE2:
      "To complete the audit you must review the list of employees you are set-up to recieve notifications for and confirm whether they are Correct and Require Removal.",
    NOTIFICATION_AUDIT_DUE_TEXT_IMPORTANT:
      "You will not be able to search for employees until you have reviewed your My Employees list.",
    THANK_YOU_AUDIT_MODAL_TEXT:
      "Thank you for completing the Notification Audit.\nYou can now freely search for employee records.\nA new audit will need to be completed in {numDays} days.",
    IMPORTANT: "IMPORTANT",
    REVIEW_MY_EMPLOYEES: "Review My Employees",
    REMOVAL_CONFIRMATION: "Removal Confirmation",
    CONFIRM_REMOVE_ACCESS:
      "Are you sure you want to remove your access to {name}'s record ?\n\nThis means you can no longer view their absence detials and they will not be included in any of your reports.",
    REMOVE_ACCESS: "Remove Access",
    REQUIRES_REMOVAL: "Requires Removal",
    CONFIRM_AUDIT_COMPLETE: "Confirm Audit Complete",
    CHARACTER_COUNTER: "{available} characters remaining",
  },
};
